import React, { Component } from "react";

import axios from "../../services/axios";

import Header from "./Header";
import Body from "./Body";

// textos
import Texts from "./Text";

export default class Contato extends Component {
  constructor(props) {
    super(props);

    this.state = {
      form: { email: "", password: "" },
      images: [],
      nome: "",
      telefone: "",
      email: "",
      mensagem: "",
      setor: "none",
      errContato: false,
      showLoading: false,
      showForm: true,
      language: props.language,
      text: new Texts(props.language)
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.imagesHandle = this.imagesHandle.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.newMessage = this.newMessage.bind(this);
    this.handleLanguage = props.handleLanguage.bind(this);
    this.handleChangeText = this.handleChangeText.bind(this);
    this.tryAgain = this.tryAgain.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleInputChange(e) {
    e.preventDefault();
    const target = {};
    target[e.target.name] = e.target.value;
    this.setState(target);
  }

  login = async () => {
    try {
      const response = axios.post("/login", this.state.form);
    } catch (err) {
      console.error(err);
    }
  };

  imagesHandle = async () => {
    try {
      const response = axios.get("/imagens", {
        Authorization: this.state.token
      });
      this.setState({ images: response.data });
    } catch (err) {
      console.error(err);
    }
  };

  newMessage() {
    this.setState({
      setor: "none",
      nome: "",
      telefone: "",
      email: "",
      mensagem: "",
      showForm: true
    });
  }

  validate() {
    let validator = true;

    const { setor, nome, email, telefone, mensagem } = this.state;
    const expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;

    let missing = [];

    if (setor === "" || setor === null) {
      validator = false;
      missing.push(" 'Setor' ");
    }

    if (nome === "" || setor === null) {
      validator = false;
      missing.push(" 'Nome' ");
    }

    if (!expression.test(email) || email === "" || email === null) {
      validator = false;
      missing.push(" 'Email' ");
    }

    if (telefone.length <= 10 || telefone === null) {
      validator = false;
      missing.push(" 'Setor' ");
    }

    if (mensagem === "" || mensagem === null) {
      validator = false;
      missing.push(" 'Setor' ");
    }

    return [validator, missing];
  }

  async handleSubmit() {
    this.setState({ showLoading: true, showForm: false });
    const { nome, email, telefone, mensagem, setor } = this.state;
    let response = [];

    if (this.validate()[0]) {
      try {
        response = await axios.post("send-email", {
          nome,
          email_from: { email },
          telefone,
          mensagem,
          to: setor
        });

        this.setState({ showLoading: false, showForm: false });
        let { status, feedback } = response;

        if (status !== 200) {
          throw feedback;
        }
      } catch (error) {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          this.setState({
            errContato:
              this.state.language === "br"
                ? "Erro no envio de dados do formulário, por favor, verifique os dados e tente novamente"
                : "An error happened whilte sendind the form data, please, check all fields and try again"
          });
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          this.setState({
            errContato:
              this.state.language === "br"
                ? "Erro de comunicação com o servidor"
                : "Server communication failed"
          });
        } else {
          // Something happened in setting up the request that triggered an Error
          this.setState({
            errContato:
              this.state.language === "br"
                ? "A requisição retornou com erro"
                : "The request returned an error"
          });
        }
      }
    } else {
      let missing = "Error: ";

      this.validate()[1].map(field => missing.concat(field));

      this.setState({
        showForm: true,
        showLoading: false,
        errContato: missing
      });
    }

    if (!this.validate()[0]) {
      this.setState({
        errContato:
          this.state.language === "br"
            ? "Erro na validação dos dados enviados"
            : "An error was found while validating sent data"
      });
    }
  }

  handleChangeText(lang) {
    this.handleLanguage(lang);
    this.setState({ text: new Texts(lang) });
  }

  tryAgain() {
    this.setState({
      ...this.state,
      showLoading: false,
      errContato: false,
      showForm: true
    });
  }

  render() {
    const settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      appendDots: dots => <ul>{dots}</ul>
    };

    return (
      <div>
        <Header
          text={this.state.text}
          handleInputChange={this.handleInputChange}
          login={this.login}
          handleLanguage={this.handleChangeText}
          language={this.state.language}
        />

        <Body
          text={this.state.text}
          handleInputChange={this.handleInputChange}
          tryAgain={this.tryAgain}
          mensagem={this.state.mensagem}
          email={this.state.email}
          telefone={this.state.telefone}
          nome={this.state.nome}
          showLoading={this.state.showLoading}
          showForm={this.state.showForm}
          errContato={this.state.errContato}
          setor={this.state.setor}
          handleSubmit={this.handleSubmit}
          newMessage={this.newMessage}
          language={this.state.language}
        />
      </div>
    );
  }
}
